import { MemoProjectConnectionForm, useSupportConnection } from '@integrations/memo-project/react';
import { connectionFormStyles } from '../../lib/integrations';

// Impostazioni › Segnalazioni: il collegamento a Flow. Una persona approva la richiesta su
// Flow; da lì ogni anomalia — un errore del server o del worker, un crash della plancia — arriva
// da sola. Tutto passa dalle rotte /api/support/* di PopTown: il browser non parla mai con Flow
// e il token resta sul server.
export function SupportTab() {
  const connection = useSupportConnection({});
  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <p className="t-small dim" style={{ margin: 0 }}>
        Collegato a Flow, PopTown vi manda da solo le sue anomalie: errori del server e del worker,
        crash della plancia. I ticket si leggono e si gestiscono in Flow.
      </p>
      <MemoProjectConnectionForm
        {...connection}
        title="Collegamento a Flow"
        styles={connectionFormStyles}
      />
    </div>
  );
}
